import Vue from 'vue';
import Vuex from 'vuex';
import { saveCategoriesPlugin, saveDashboardConfigPlugin } from '../utils';

Vue.use(Vuex);

const categories = JSON.parse(localStorage.getItem('categories'));

function categorySort(a,b) {
  if (a.name < b.name) {
    return -1;
  } else if (b.name < a.name) {
    return 1;
  }
}

export default new Vuex.Store({
  plugins: [
    saveCategoriesPlugin,
    saveDashboardConfigPlugin
  ],
  state: {
    dashboardConfig: null,
    categories: categories || [],
    window: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    snackbars: [],
  },
  getters: {
    isMobile: state => {
      if (state.window.width <= 768) {
        return true;
      }
      return false;
    },
    allCategories: state => {
      return state.categories;
    },
    highSchoolCategories: state => {
      if (state.categories.length > 0) {
        let highSchool = state.categories.filter(c => {
          return c.parent_id === 1 && c.contributes_content === true;
        });
        let sorted = highSchool.sort((a,b) => {
          return categorySort(a,b)
        });
        return sorted;
      }
      return [];
    },
    mainCategories: state => {
      if (state.categories.length > 0) {
        return state.categories.filter(c => {
          return c.type === 'main';
        });
      }
    },
    subCategories: state => {
      if (state.categories.length > 0) {
        return state.categories.filter(c => {
          return c.type === 'sub';
        });
      }
    },
    showCategories: state => {
      if (state.categories.length > 0) {
        return state.categories.filter(c => {
          return c.type === 'show';
        });
      }
    },
    hiddenCategories: state => {
      if (state.categories.length > 0) {
        return state.categories.filter(c => {
          return c.type === 'internal' || c.type === 'hidden';
        });
      }
    },
    localCategories: state => {
      if (state.categories.length > 0) {
        return state.categories.filter(c => {
          return c.parent_id === 4;
        });
      }
      return [];
    },
    getCategoryById: state => id => state.categories.find(cat => cat.id == id),
  },
  mutations: {
    SET_DASHBOARD_CONFIG: (state, config) => (state.dashboardConfig = config),
    SET_CATEGORIES: (state, categories) => (state.categories = categories),
    UPDATE_WINDOW_SIZE: (state, size) => (state.window = size),
    ADD_SNACKBAR: (state, snackbar) => (state.snackbars = state.snackbars.concat(snackbar)),
  },
  actions: {
    async getDashboardConfig({ commit }) {
      const res = await axios.get('getDashboardConfig');
      if (res.data.success) {
        commit('SET_DASHBOARD_CONFIG', res.data.config)
      }
    },
    async getCategories({ commit }) {
      const res = await axios.get('getCategories');
      if (res.data.success) {
        commit('SET_CATEGORIES', res.data.categories);
      }
    },
    onWindowResize({ commit }) {
      let size = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      commit('UPDATE_WINDOW_SIZE', size);
    },
    addSnackbar({ commit }, snackbar) {
      snackbar.showing = true;
      snackbar.color = snackbar.color || 'success';
      snackbar.timeout = snackbar.timeout !== undefined ? snackbar.timeout : 3000;
      commit('ADD_SNACKBAR', snackbar);
    },
  },
  modules: {},
});
